export const removeNewDeleted = ({ id, del }: { id?: number; del?: boolean }) =>
  !!id || !del;

export const removeFalseDelete = ({ del, ...data }: { del?: boolean }) =>
  del ? { ...data, del } : data;
